module.exports = __webpack_public_path__ + "928710777a3ac496db364c6649dbc441.jpg";